var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditLogoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37297 2.66666H4.55751C3.43122 2.66666 2.86808 2.66666 2.43789 2.88464C2.05949 3.07639 1.75184 3.38235 1.55903 3.75867C1.33984 4.1865 1.33984 4.74655 1.33984 5.86666V11.4667C1.33984 12.5868 1.33984 13.1468 1.55903 13.5746C1.75184 13.951 2.05949 14.2569 2.43789 14.4487C2.86808 14.6667 3.43122 14.6667 4.55751 14.6667H10.1884C11.3147 14.6667 11.8779 14.6667 12.308 14.4487C12.6864 14.2569 12.9941 13.951 13.1869 13.5746C13.4061 13.1468 13.4061 12.5868 13.4061 11.4667V8.66666M5.36191 10.6667H6.48443C6.81235 10.6667 6.97631 10.6667 7.13061 10.6298C7.26741 10.5972 7.39819 10.5433 7.51814 10.4702C7.65344 10.3877 7.76938 10.2724 8.00125 10.0418L14.4116 3.66666C14.9669 3.11437 14.9669 2.21894 14.4116 1.66666C13.8563 1.11437 12.9559 1.11437 12.4006 1.66665L5.9902 8.04182C5.75832 8.27242 5.64238 8.38772 5.55947 8.52228C5.48596 8.64157 5.43179 8.77163 5.39895 8.90768C5.36191 9.06113 5.36191 9.22419 5.36191 9.55031V10.6667Z",
    stroke: "#A39992",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLogoOff);
export default __webpack_public_path__ + "static/media/Edit-logo-off.cc9363eae376888636f6b16f634abde7.svg";
export { ForwardRef as ReactComponent };